module.exports = new __parcel__URL__("github.d9710574.svg").toString();